const useLayout = () => {
  const isMasterData =
    location.pathname === "/admin/master-data" ||
    location.pathname.startsWith("/admin/master-data/");

  return {
    isMasterData,
  };
};

export default useLayout;
